var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEnum, IsNumber, IsOptional, IsString, IsUUID, MaxLength, } from 'class-validator';
import { Difficulty } from '../enums/difficulty.enum.js';
import { Visibility } from '../enums/visibility.enum.js';
import { BodyRegionFullSizeDto } from './body-region.full-size.dto.js';
import { ExercisePackageFullSizeDto } from './exercise-package.full-size.dto.js';
/**
 * How long the optional "Gerät" of an exercise may be. It is a device name, not
 * a description — "Faszienrolle, Matte und Hantel" is thirty characters — and it
 * is printed on the program PDF, where the row that holds it is a fixed height.
 *
 * The column behind it is `varchar(255)`, so values written before this limit
 * existed can be longer; such an exercise has to be shortened before it saves
 * again. The input counts up to this, so it says so on screen.
 */
export const MAX_EXERCISE_DEVICE_TEXT_LENGTH = 50;
export class CreateExerciseDto {
    title;
    filename;
    thumbFilename;
    originalFilename;
    shotNo;
    text;
    indication;
    duration;
    deviceText;
    weightNeeded;
    difficulty;
    visibility;
    exercisePackages = [];
    bodyRegions = [];
    sharedWithUserId;
    markAsFavourite;
}
__decorate([
    IsString(),
    __metadata("design:type", Object)
], CreateExerciseDto.prototype, "title", void 0);
__decorate([
    IsString(),
    __metadata("design:type", Object)
], CreateExerciseDto.prototype, "filename", void 0);
__decorate([
    IsString(),
    __metadata("design:type", Object)
], CreateExerciseDto.prototype, "thumbFilename", void 0);
__decorate([
    IsString(),
    __metadata("design:type", Object)
], CreateExerciseDto.prototype, "originalFilename", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateExerciseDto.prototype, "shotNo", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateExerciseDto.prototype, "text", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateExerciseDto.prototype, "indication", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateExerciseDto.prototype, "duration", void 0);
__decorate([
    IsString(),
    IsOptional(),
    MaxLength(MAX_EXERCISE_DEVICE_TEXT_LENGTH),
    __metadata("design:type", Object)
], CreateExerciseDto.prototype, "deviceText", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateExerciseDto.prototype, "weightNeeded", void 0);
__decorate([
    IsEnum(Difficulty),
    IsOptional(),
    __metadata("design:type", String)
], CreateExerciseDto.prototype, "difficulty", void 0);
__decorate([
    IsEnum(Visibility),
    __metadata("design:type", String)
], CreateExerciseDto.prototype, "visibility", void 0);
__decorate([
    IsArray(),
    Type(() => ExercisePackageFullSizeDto),
    __metadata("design:type", Array)
], CreateExerciseDto.prototype, "exercisePackages", void 0);
__decorate([
    IsArray(),
    Type(() => BodyRegionFullSizeDto),
    __metadata("design:type", Array)
], CreateExerciseDto.prototype, "bodyRegions", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateExerciseDto.prototype, "sharedWithUserId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateExerciseDto.prototype, "markAsFavourite", void 0);
//# sourceMappingURL=create-exercise.dto.js.map